import React from "react";
import { useAdminAuth } from "../../hooks/useAdminAuth";
import Icon from "../ui/Icon";

interface AdminLayoutProps {
  children: React.ReactNode;
  title?: string;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({
  children,
  title = "AI 답변 검수",
}) => {
  const { adminLogout } = useAdminAuth();

  const handleLogout = () => {
    if (confirm("관리자 로그아웃 하시겠습니까?")) {
      adminLogout();
    }
  };

  return (
    <div className="h-screen-dvh bg-gray-50 flex flex-col overflow-hidden">
      {/* 간소화된 헤더 */}
      <header className="bg-white border-b border-gray-200 px-4 py-3 flex items-center justify-between shadow-sm">
        {/* 좌측: 제목 */}
        <div className="flex items-center">
          <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center mr-3">
            <Icon name="shield" className="text-white" size="sm" />
          </div>
          <div>
            <h1 className="text-lg font-semibold text-gray-800">{title}</h1>
            <p className="text-xs text-gray-500">관리자 검수 시스템</p>
          </div>
        </div>

        {/* 우측: 로그아웃 */}
        <button
          onClick={handleLogout}
          className="flex items-center space-x-2 px-3 py-2 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition-colors"
          title="로그아웃"
        >
          <Icon name="logOut" size="sm" />
          <span className="text-sm font-medium">로그아웃</span>
        </button>
      </header>

      {/* 메인 콘텐츠 */}
      <main className="flex-1 overflow-y-auto p-6">{children}</main>
    </div>
  );
};

export default AdminLayout;
